var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "p-1 draggable-container" },
    [
      _c(
        "b-row",
        {
          staticClass: "draggable-statistics statistics-item",
          attrs: { "no-gutters": "" },
        },
        [
          _c(
            "b-col",
            {
              directives: [
                {
                  name: "click-outside",
                  rawName: "v-click-outside",
                  value: _vm.handleClickOutside,
                  expression: "handleClickOutside",
                },
              ],
              staticClass: "statistics-left",
              attrs: { cols: "12" },
            },
            [
              !_vm.editing
                ? _c(
                    "p",
                    {
                      staticClass:
                        "state-name regular bold text-gray mr-2 ml-0 my-0 w-100",
                      attrs: { title: _vm.label.trim() },
                      on: {
                        dblclick: function ($event) {
                          return _vm.setEditing(true)
                        },
                      },
                    },
                    [
                      _vm.hasEmailAutomation
                        ? _c(
                            "a",
                            {
                              directives: [
                                {
                                  name: "b-tooltip",
                                  rawName: "v-b-tooltip.hover.top",
                                  value: {
                                    title: _vm.$t(
                                      "boards.messages.thisColumnHasAnEmailAutomation"
                                    ),
                                    boundary: "window",
                                  },
                                  expression:
                                    "{\n            title: $t('boards.messages.thisColumnHasAnEmailAutomation'),\n            boundary: 'window'\n          }",
                                  modifiers: { hover: true, top: true },
                                },
                              ],
                              staticClass:
                                "clickable automation-email-defined mr-1",
                              on: { click: _vm.handleAutomationDefinedClick },
                            },
                            [
                              _c("img", {
                                attrs: {
                                  src: require("@Broker/@Assets/icon/message.png"),
                                },
                              }),
                            ]
                          )
                        : _vm._e(),
                      _vm._v(
                        "\n        " + _vm._s(_vm.label.trim()) + "\n        "
                      ),
                      _c(
                        "span",
                        {
                          staticClass: "clickable edit-state",
                          on: {
                            click: function ($event) {
                              return _vm.setEditing(true)
                            },
                          },
                        },
                        [
                          _c("i", {
                            staticClass: "fa fa-pencil",
                            attrs: { "aria-hidden": "true" },
                          }),
                        ]
                      ),
                    ]
                  )
                : _c(
                    "form",
                    {
                      staticClass:
                        "client-profile-states-forms edit-state-wrapper position-relative",
                      on: {
                        submit: function ($event) {
                          $event.preventDefault()
                          $event.stopPropagation()
                          return _vm.handleLabelSubmit.apply(null, arguments)
                        },
                        mousedown: function ($event) {
                          $event.stopPropagation()
                        },
                      },
                    },
                    [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.newLabel,
                            expression: "newLabel",
                          },
                        ],
                        ref: "newLabelInput",
                        staticClass: "form-control edit-state-input w-100",
                        attrs: {
                          type: "text",
                          placeholder: "Edit state",
                          name: "label",
                        },
                        domProps: { value: _vm.newLabel },
                        on: {
                          input: function ($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.newLabel = $event.target.value
                          },
                        },
                      }),
                      _vm._v(" "),
                      _c(
                        "b-button",
                        {
                          staticClass: "save-state h-100 text-black",
                          attrs: { type: "submit" },
                        },
                        [_c("icon", { attrs: { name: "check" } })],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "b-button",
                        {
                          staticClass: "close-edit h-100 text-black",
                          on: {
                            click: function ($event) {
                              return _vm.setEditing(false)
                            },
                          },
                        },
                        [_c("icon", { attrs: { name: "ban" } })],
                        1
                      ),
                    ],
                    1
                  ),
              _vm._v(" "),
              !_vm.editing
                ? _c("icon", {
                    staticClass: "clickable show-status-settings",
                    class: { "text-primary": _vm.showingSettings },
                    attrs: { name: "cog" },
                    on: {
                      mousedown: function ($event) {
                        $event.stopPropagation()
                      },
                      click: _vm.toggleShowSettings,
                    },
                  })
                : _vm._e(),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "b-col",
            { staticClass: "statistics-right", attrs: { cols: "12" } },
            [
              _c(
                "b-row",
                { attrs: { "no-gutters": "" } },
                [
                  _c("b-col", { attrs: { cols: "12", lg: "auto" } }, [
                    _c(
                      "p",
                      {
                        staticClass:
                          "state-count text-gray d-flex mt-1 small text-left",
                      },
                      [
                        _vm._v(
                          "\n            " +
                            _vm._s(_vm.count) +
                            " " +
                            _vm._s(_vm.$tc("global.doorr.client", _vm.count)) +
                            "\n          "
                        ),
                      ]
                    ),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "col-lg col-12" }, [
                    _c("p", {
                      ref: "clientProfileValue",
                      staticClass:
                        "state-total bold text-gray big m-0 client-profile-value text-left text-lg-right",
                    }),
                  ]),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c("div", {
        staticClass:
          "d-flex justify-content-center text-center no-results-container",
      }),
      _vm._v(" "),
      _vm.showingSettings
        ? _c("settings-column", {
            attrs: {
              "status-id": _vm.id,
              "mute-automations": _vm.muteAutomations,
              "mute-notifications": _vm.muteNotifications,
              "rotting-days-threshold": _vm.rottingDaysThreshold,
              "first-column-label": _vm.FIRST_COLUMN.label,
              "is-first-column": _vm.isFirstColumn,
              count: _vm.count,
              title: _vm.label.trim(),
            },
            on: {
              change: _vm.handleConfigChange,
              move: _vm.handleColumnMove,
              delete: _vm.handleDelete,
            },
          })
        : _c("client-profile-list", {
            key: _vm.id + "-list",
            on: {
              start: _vm.handleDraggableStart,
              end: _vm.handleDraggableEnd,
            },
            model: {
              value: _vm.profilesValues,
              callback: function ($$v) {
                _vm.profilesValues = $$v
              },
              expression: "profilesValues",
            },
          }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }